module.exports = __webpack_public_path__ + "static/media/07_plantilla_cuadrada_combo_simple_cf_stills_tetra_1l_cepita_naranja.0070e425.png";